import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../../core/img/ImageWithBasePath';
// import { InputOtp } from 'primereact/inputotp';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../../../firebase'; // Import your firebase auth instance
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { notification } from 'antd'; // For notifications


const AuthModals = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [passwordResponse, setPasswordResponse] = useState({
    passwordResponseText: "Use 8 or more characters with a mix of letters, numbers, and symbols.",
    passwordResponseKey: '',
  });
  const navigate = useNavigate(); 

  const [isSignUp, setIsSignUp] = useState(false);

  const onChangePassword = (password) => {
    setPassword(password);
    if (password.match(/^$|\s+/)) {
      setPasswordResponse({
        passwordResponseText: 'Whitespaces are not allowed',
        passwordResponseKey: '',
      });
    } else if (password.length === 0) {
      setPasswordResponse({
        passwordResponseText: '',
        passwordResponseKey: '',
      });
    } else if (password.length < 8) {
      setPasswordResponse({
        passwordResponseText: 'Weak. Must contain at least 8 characters',
        passwordResponseKey: '0',
      });
    } else if (
      password.search(/[a-z]/) < 0 ||
      password.search(/[A-Z]/) < 0 ||
      password.search(/[0-9]/) < 0
    ) {
      setPasswordResponse({
        passwordResponseText: 'Average. Must contain at least 1 upper case and number',
        passwordResponseKey: '1',
      });
    } else if (password.search(/(?=.*?[#?!@$%^&*-])/) < 0) {
      setPasswordResponse({
        passwordResponseText: 'Almost. Must contain a special symbol',
        passwordResponseKey: '2',
      });
    } else {
      setPasswordResponse({
        passwordResponseText: 'Awesome! You have a secure password.',
        passwordResponseKey: '3',
      });
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
  
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      // On successful login
      openNotificationWithIcon("success", "Login Success", "You have successfully logged in!");
      // Redirect to /home
      navigate('/home'); // Use navigate to redirect the user
    } catch (error) {
      setError(error.message);
      openNotificationWithIcon("error", "Login Failed", error.message);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      // On successful sign-up
      openNotificationWithIcon("success", "Sign Up Success", "Your account has been created successfully!");
      // Redirect to /home after sign-up
      navigate('/home');
    } catch (error) {
      setError(error.message);
      openNotificationWithIcon("error", "Sign Up Failed", error.message);
    }
  };

  const openNotificationWithIcon = (type, title, description) => {
    notification[type]( {
      message: title,
      description,
    });
  };

  return (
    <>
  {/* Login Modal */}
{/* Login Modal */}
<div className="modal fade" id="login-modal" tabIndex={-1} data-bs-backdrop="static" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
              <Link to="#" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-circle-x-filled fs-20" />
              </Link>
            </div>
            <div className="modal-body p-4">
              <form onSubmit={handleLogin}>
                <div className="text-center mb-3">
                  <h3 className="mb-2">Welcome</h3>
                  <p>Enter your credentials to access your account</p>
                </div>
                <div className="mb-3">
                  <label className="form-label">User Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => onChangePassword(e.target.value)}
                    required
                  />
                  <p className="text-danger">{passwordResponse.passwordResponseText}</p>
                </div>
                <div className="mb-3">
                  <button type="submit" className="btn btn-lg btn-linear-primary w-100">
                    Sign In
                  </button>
                </div>
                <div className="login-or mb-3">
                  <span className="span-or">Or sign in with </span>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <Link to="#" className="btn btn-light flex-fill d-flex align-items-center justify-content-center me-3">
                    <ImageWithBasePath src="assets/img/icons/google-icon.svg" className="me-2" alt="Img" />
                    Google
                  </Link>
                  <Link to="#" className="btn btn-light flex-fill d-flex align-items-center justify-content-center">
                    <ImageWithBasePath src="assets/img/icons/fb-icon.svg" className="me-2" alt="Img" />
                    Facebook
                  </Link>
                </div>
                <div className="d-flex justify-content-center">
                  <p>
                    Don’t have an account?{" "}
                    <Link
                      to="#"
                      className="text-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#register-modal"
                    >
                      Join us Today
                    </Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  {/* /Login Modal */}
  {/* Register Modal */}
  <div className="modal fade" id="register-modal" tabIndex={-1} data-bs-backdrop="static" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
              <Link to="#" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-circle-x-filled fs-20" />
              </Link>
            </div>
            <div className="modal-body p-4">
              <form onSubmit={handleSignUp}>
                <div className="text-center mb-3">
                  <h3 className="mb-2">Registration</h3>
                  <p>Enter your credentials to create your account</p>
                </div>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => onChangePassword(e.target.value)}
                    required
                  />
                  <p className="text-danger">{passwordResponse.passwordResponseText}</p>
                </div>
                <div className="mb-3">
                  <button type="submit" className="btn btn-lg btn-linear-primary w-100">
                    Sign Up
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
  {/* /Register Modal */}
  {/* Forgot Modal */}
  <div
    className="modal fade"
    id="forgot-modal"
    tabIndex={-1}
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
          <Link
            to="#"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i className="ti ti-circle-x-filled fs-20" />
          </Link>
        </div>
        <div className="modal-body p-4">
          <form action="#">
            <div className="text-center mb-3">
              <h3 className="mb-2">Forgot Password?</h3>
              <p>
                Enter your email, we will send you a otp to reset your password.
              </p>
            </div>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input type="email" className="form-control" />
            </div>
            <div className="mb-3">
              <button
                type="button"
                className="btn btn-lg btn-linear-primary w-100"
                data-bs-toggle="modal"
                data-bs-target="#otp-email-modal"
              >
                Submit
              </button>
            </div>
            <div className=" d-flex justify-content-center">
              <p>
                Remember Password?{" "}
                <Link
                  to="#"
                  className="text-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#login-modal"
                >
                  Sign In
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  {/* /Forgot Modal */}
  {/* Email otp Modal */}
  <div
    className="modal fade"
    id="otp-email-modal"
    tabIndex={-1}
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
          <Link
            to="#"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i className="ti ti-circle-x-filled fs-20" />
          </Link>
        </div>
        <div className="modal-body p-4">
          <form action="#" className="digit-group">
            <div className="text-center mb-3">
              <h3 className="mb-2">Email OTP Verification</h3>
              <p className="fs-14">
                OTP sent to your Email Address ending ******doe@example.com
              </p>
            </div>
            <div className="text-center otp-input">
              <div className="d-flex align-items-center justify-content-center mb-3">
              {/* <InputOtp value={token} onChange={(e) => setTokens(e.value)} integerOnly/> */}
              </div>
              <div>
                <div className="badge bg-danger-transparent mb-3">
                  <p className="d-flex align-items-center ">
                    <i className="ti ti-clock me-1" />
                    09:59
                  </p>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                  <p>
                    Didn&apos;t get the OTP?{" "}
                    <Link to="#" className="text-primary">
                      Resend OTP
                    </Link>
                  </p>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-lg btn-linear-primary w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#otp-phone-modal"
                  >
                    Verify &amp; Proceed
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  {/* /Email otp Modal */}
  {/* Phone otp Modal */}
  <div
    className="modal fade"
    id="otp-phone-modal"
    tabIndex={-1}
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
          <Link
            to="#"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i className="ti ti-circle-x-filled fs-20" />
          </Link>
        </div>
        <div className="modal-body p-4">
          <form action="#" className="digit-group">
            <div className="text-center mb-3">
              <h3 className="mb-2">Phone OTP Verification</h3>
              <p>OTP sent to your mobile number ending&nbsp;******9575</p>
            </div>
            <div className="text-center otp-input">
              <div className="d-flex align-items-center justify-content-center mb-3">
              {/* <InputOtp value={token2} onChange={(e) => setTokens2(e.value)} integerOnly/> */}
              </div>
              <div>
                <div className="badge bg-danger-transparent mb-3">
                  <p className="d-flex align-items-center ">
                    <i className="ti ti-clock me-1" />
                    09:59
                  </p>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                  <p>
                    Didn&apos;t get the OTP?{" "}
                    <Link to="#" className="text-primary">
                      Resend OTP
                    </Link>
                  </p>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-lg btn-linear-primary w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#reset-password"
                  >
                    Verify &amp; Proceed
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  {/* /Phone otp Modal */}
  {/* Reset password Modal */}
  <div
    className="modal fade"
    id="reset-password"
    tabIndex={-1}
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
          <Link
            to="#"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i className="ti ti-circle-x-filled fs-20" />
          </Link>
        </div>
        <div className="modal-body p-4">
          <div className="text-center mb-3">
            <h3 className="mb-2">Reset Password</h3>
            <p className="fs-14">
              Your new password must be different from previous used passwords.
            </p>
          </div>
          <form action="#">
            <div className="input-block mb-3">
              <div className="mb-3">
                <label className="form-label">New Password</label>
                <div className="pass-group" id="passwordInput">
                  <input type="password" value={password} onChange={(e) => onChangePassword(e.target.value)} className="form-control pass-input" />
                </div>
              </div>
              <div
                      // className={`password-strength d-flex ${
                      //   passwordResponce.passwordResponceKey === '0'
                      //     ? 'poor-active'
                      //     : passwordResponce.passwordResponceKey === '1'
                      //     ? 'avg-active'
                      //     : passwordResponce.passwordResponceKey === '2'
                      //     ? 'strong-active'
                      //     : passwordResponce.passwordResponceKey === '3'
                      //     ? 'heavy-active'
                      //     : ''
                      // }`}
                      // id="passwordStrength"
                    >
                      <span id="poor" className="active" />
                      <span id="weak" className="active" />
                      <span id="strong" className="active" />
                      <span id="heavy" className="active" />
                    </div>
              <div id="passwordInfo" className="mb-2" />
              <p className="fs-12">
              {/* {passwordResponce.passwordResponceText} */}
              </p>
            </div>
            <div className="mb-3">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <label className="form-label">Confirm Password</label>
              </div>
              <input type="password" className="form-control" />
            </div>
            <div>
              <button
                type="button"
                className="btn btn-lg btn-linear-primary w-100"
                data-bs-toggle="modal"
                data-bs-target="#success_modal"
              >
                Save Change
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  {/* /Reset password Modal */}
  {/* success message Modal */}
  <div
    className="modal fade"
    id="success-modal"
    tabIndex={-1}
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header d-flex align-items-center justify-content-end pb-0 border-0">
          <Link
            to="#"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i className="ti ti-circle-x-filled fs-20" />
          </Link>
        </div>
        <div className="modal-body p-4">
          <div className="text-center">
            <span className="success-check mb-3 mx-auto">
              <i className="ti ti-check" />
            </span>
            <h4 className="mb-2">Success</h4>
            <p>Your new password has been successfully saved</p>
            <div>
              <button
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-lg btn-linear-primary w-100"
              >
                Back to Sign In
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* /success message Modal */}
</>

  )
}

export default AuthModals